import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { useHistory } from "react-router-dom";

import "./mobile-main-new-mgs-style.scss";

import MobileProductListSkeleton from "@src/componentsNew/Skeleton/mobile/components/MobileProductListSkeleton";
import Button from "@src/componentsNew/Buttons/Button";
import ProductListTitle from "@src/componentsNew/ProductListTitle/ProductListTitle";
import SectionDivider from '@src/componentsNew/SectionDivider';
import MobileHorizontalProductThumbnail from "@src/componentsNew/ProductThumbnail/HorizontalProductThumbnail/MobileHorizontalProductThumbnail";

import ChevronRightIcon from "@src/componentsNew/Icons/Icons/ChevronRightIcon";
import { StockAvailability } from "__generated__/globalTypes";
import { mobileProducts } from "@src/components/ProductPage/ProductList/__generated__/mobileProducts";
import { MOBILE_PRODUCT_LIST } from "@src/components/ProductPage/ProductList/queries";

import { getGraphqlIdFromDBId } from "@src/core/utils";

const MobileMainNewMGS = () => {
  const history = useHistory();
  const mainNewMGSDetailUrl = `/en/products/collection/new-arrivals-in-global-store-${process.env.NEW_ARRIVAL_MGS_COLLECTION_ID}/`;

  const { data, loading } = useQuery<mobileProducts>(MOBILE_PRODUCT_LIST, {
    variables: {
      collections: [getGraphqlIdFromDBId(process.env.NEW_ARRIVAL_MGS_COLLECTION_ID, "Collection")],
      stockAvailability: StockAvailability.IN_STOCK,
      sortBy: {
        field: "POPULARITY",
        direction: "DESC"
      },
      first: 8
    }
  });

  if (loading) {
    return (
      <MobileProductListSkeleton
        type="vertical"
        hasTitle={true}
        hasTitleRightArea={true}
        hasBottomDivider={true} />
    );
  }

  return (
    data?.products?.totalCount > 0 ?
      <div className="mobile-new-arrival-mgs-wrapper">
        <ProductListTitle
          title="New Arrivals in Global Store"
          typoVariant="h8"
          typoComponent="h4"
          url={mainNewMGSDetailUrl}
          isShowRightBtn={true}
          rightBtnText=""
          rightBtnColor="#666666"
          isShowArrow={true} />

        <div className="mobile-new-arrival-mgs-products-thumbnail-wrapper">
          {
            data?.products?.edges
              .map((edge, idx) =>
                <MobileHorizontalProductThumbnail key={idx} product={edge.node} />
              )
          }
          <Button
            size="small"
            variant="text"
            style={{ color: "#F82296" }}
            endIcon={<ChevronRightIcon width="20" height="20" strokeColor="#F82296" />}
            onClick={() => history.push(mainNewMGSDetailUrl)}>
            See All
          </Button>
        </div>

        <SectionDivider style={{ marginTop: "24px" }} />
      </div> : null
  );
};

export default MobileMainNewMGS;
